import { useNavigate } from 'react-router'

import { ROUTES } from '@/app/router/paths'
import type { Event, EventsPage } from '@/services/api/schemas/events'
import { useEventsFilters } from '@/services/events/useEventsFilters'
import { getErrorMessage } from '@/shared/lib/format'
import { EventRow, Panel, Skeleton, StateBlock } from '@/shared/ui'

import s from './RecentEvents.module.css'

interface RecentEventsProps {
  page: EventsPage | undefined
  isLoading: boolean
  error: unknown
  onRetry: () => void
  className?: string
}

export function RecentEvents({ page, isLoading, error, onRetry, className }: RecentEventsProps) {
  const navigate = useNavigate()
  const filters = useEventsFilters()

  const openEvent = (event: Event) => {
    filters.setType('all')
    filters.setPeriod('all')
    filters.select(event.id)
    navigate(ROUTES.events)
  }

  return (
    <Panel
      title="Последние события"
      subtitle={page ? `${page.data.length} из ${page.total} за всё время` : undefined}
      className={className}
      flush
    >
      <div className={s.list}>
        {error ? (
          <StateBlock
            kind="error"
            message={`Не удалось получить события. ${getErrorMessage(error)}`}
            onRetry={onRetry}
          />
        ) : null}
        {isLoading &&
          Array.from({ length: 5 }, (_, i) => (
            <div key={i} className={s.skeletonRow}>
              <Skeleton height={34} />
            </div>
          ))}
        {page?.data.length === 0 && <StateBlock kind="empty" message="Событий пока нет" />}
        {page?.data.map((event) => (
          <EventRow key={event.id} event={event} onClick={openEvent} />
        ))}
      </div>
      <button type="button" className={s.more} onClick={() => navigate(ROUTES.events)}>
        Показать все события
      </button>
    </Panel>
  )
}
